module.exports = __webpack_public_path__ + "img/3rdOnLandingPage.c878d258.jpeg";